import Vue from 'vue'
import Vuex from 'vuex'
import * as MT from './mutation-types'
import axios from 'axios'
import util from './plugins/meshstats-util'
Vue.use(Vuex)
export const store = new Vuex.Store({
  state: {
    centerPoint: [35.012500, 135.768750], //Kyoto City
    points: [],
    featureCollection: null,
    meshHeaders: [],
    meshData: [],
    relevantData: [],
    aggregatedData: {},
    loadingStatus: false,
    sampleList: [],
    selectedMeasures: []
  },
  mutations: {
    [MT.SET_CENTER_POINT](state, point) {
      state.centerPoint = [point.latitude, point.longitude];
    },
    [MT.PUSH_POINT](state, point) {
      state.points.push(point);
    },
    [MT.REMOVE_ALL_POINTS](state) {
      state.points = [];
    },
    [MT.SET_FEATURE_COLLECTION](state, collection) {
      state.featureCollection = collection;
    },
    [MT.SET_MESHDATA](state, meshdata) {
      state.meshData = meshdata;
    },
    [MT.SET_MESHHEADERS](state, meshheaders) {
      state.meshHeaders = meshheaders;
    },
    [MT.SET_RELEVANT_DATA](state, relevantData) {
      state.relevantData = relevantData
    },
    [MT.SET_LOADING_STATUS](state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    [MT.SET_SAMPLE_LIST](state, sampleList) {
      state.sampleList = sampleList
    },
    [MT.SET_MEASURES](state, measures) {
      state.selectedMeasures = measures
    }
  },
  getters: {
    centerPoint(state) {
      return state.centerPoint
    },
    points(state) {
      return state.points
    },
    geoPoints(state) {
      return state.featureCollection
    },
    meshHeaders(state) {
      return state.meshHeaders
    },
    meshData(state) {
      return state.meshData
    },
    dimensions(state) {
      let headers = state.meshHeaders.map((h) => { return h })
      headers.splice(0, 10)
      return headers;
    },
    relevantData(state) {
      return state.relevantData
    },
    aggregatedData(state) {
      return state.aggregatedData
    },
    loadingStatus(state) {
      return state.loadingStatus
    },
    sampleList(state) {
      return state.sampleList
    },
    selectedMeasures(state) {
      return state.selectedMeasures
    }
  },
  actions: {
    fetchSampleList: (context) => {
      context.commit(MT.SET_LOADING_STATUS, true);
      const url = "sample_list.php";
      axios
        .get(url, {})
        .then(function (response) {
          context.commit(MT.SET_SAMPLE_LIST, response.data);
        })
        .catch(function (error) {
          window.console.error(error);
        })
        .finally(function () {
          context.commit(MT.SET_LOADING_STATUS, false);
        });
    },
    fetchMeshdata: (context) => {
      context.commit(MT.SET_LOADING_STATUS, true);
      const url = util.busapiURL;
      const params = util.busapiParams(
        context.state.centerPoint[0],
        context.state.centerPoint[1],
        10);
      axios
        .get(url, { params })
        .then(function (response) {
          let lines = response.data.split(/\r\n|\r|\n/).map(line => line.split(/,|\t/));
          let headers = lines.splice(0, 1)[0].map((h) => {
            return h.replace("km<sup>2</sup>", "㎢").replace("km<SUP>2</SUP>", "㎢")
          });
          context.commit(MT.SET_MESHHEADERS, headers.map((header) => {
            return { text: header, value: header };
          }));
          context.commit(MT.SET_MESHDATA, lines.map(line => {
            let data = {}
            line.forEach((element, index) => {
              data[headers[index]] = element
            });
            return data;
          }));
          context.dispatch('findRelation')
        })
        .catch(function (error) {
          window.console.error(error);
        })
        .finally(function () {
          context.commit(MT.SET_LOADING_STATUS, false);
        });
    },
    findRelation: (context) => {
      let relevantData = []
      context.state.points.map((point) => {
        let relatedData = null
        let relatedCount = 0
        context.state.meshData.map((data) => {
          if (util.pointHasRelation(point, data)) {
            relatedCount += 1
            if (relatedData == null) {
              relatedData = data
            } else {
              Object.keys(data).map((dimension, index) => {
                if (index < 10) return
                let value = 0
                let dataValue = parseFloat(relatedData[dimension])
                if (!isNaN(dataValue)) value += dataValue
                dataValue = parseFloat(data[dimension])
                if (!isNaN(dataValue)) value += dataValue
                relatedData[dimension] = value / relatedCount
              })
            }
          }
        })
        if (relatedData != null) {
          relevantData.push({ point: point, data: relatedData })
        }
      })
      context.commit(MT.SET_RELEVANT_DATA, relevantData)
      context.dispatch('aggregateData')
    },
    aggregateData(context) {
      context.state.aggregatedData = {}
      context.state.relevantData.map((item) => {
        Object.keys(item.data).map((dimension, index) => {
          if (index < 10) return
          if (!(dimension in context.state.aggregatedData)) {
            context.state.aggregatedData[dimension] = []
          }
          context.state.aggregatedData[dimension].push({
            id: item.point.id,
            name: item.point.name,
            value: parseFloat(item.data[dimension]).toFixed(2)
          })
        })
      })
    }
  }
})
